import React, { useState } from "react";
import "./Training.css";
import { Link } from "react-router-dom";

import sysquareLogo from "./assets/sysquare.png";
import hoppinghawksLogo from "./assets/hoppinghawks.png";
import celebalLogo from "./assets/images.png";
import techanalogyLogo from "./assets/techanalogy.png";
import aaronLogo from "./assets/aaron.jpg";
import udemyLogo from "./assets/udemy.png";
import courseraLogo from "./assets/coursera.jpg";

const trainingData = [
  
  {
    year: "2021",
    date: "September 13, 2021",
    title:
      'Completed Coursera "Responsive Web Design in Adobe XD" course sponsored by Google',
    logo: courseraLogo,
    skills: ["Adobe XD", "Prototyping", "UX Design"],
  },
  {
    year: "2022",
    date: "July 30, 2022",
    title: "Completed Udemy React.js Course",
    logo: udemyLogo,
    skills: ["React Hooks", "Routing", "Deployment"],
  },
  {
    year: "2022",
    date: "August 8, 2022",
    title: "Completed React.js Internship from Aaron Softech Pvt. Ltd.",
    logo: aaronLogo,
    skills: ["React", "Redux", "JavaScript"],
  },
  {
    year: "2023",
    date: "February 19, 2023",
    title: "Completed Training under Graphic Designing from TechAnalogy",
    logo: techanalogyLogo,
    skills: ["Canva", "Graphic Design Basics"],
  },
  {
    year: "2023",
    date: "August 5, 2023",
    title:
      "Completed Cloud Developer (Web Development) Internship from Celebal Technologies",
    logo: celebalLogo,
    skills: ["Cloud", "Web Dev", "API Integration"],
  },
  {
    year: "2024",
    date: "July 17, 2024",
    title: "Completed Graphic Design Internship from Hopping Hawks",
    logo: hoppinghawksLogo,
    skills: ["Photoshop", "Illustrator", "Branding"],
  },
  {
    year: "2024",
    date: "April 21, 2024",
    title: "Completed React JS Internship from Sysquare",
    logo: sysquareLogo,
    skills: ["React", "UI/UX", "Frontend Development"],
  },
];

function Training() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleCard = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="training__section">
      <h2 className="timeline__heading">My Learning Journey</h2>

      <div className="timeline__container">
        <div className="timeline__line"></div>

        {trainingData.map((item, index) => (
          <div
            key={index}
            className={`timeline__event ${index % 2 === 0 ? "top" : "bottom"} ${
              index === 0 ? "highlight" : ""
            }`}
          >
            <div
              className="timeline__dot"
              onClick={() => toggleCard(index)}
            >
              <img src={item.logo} alt={item.title} />
              <span className="timeline__year">{item.year}</span>
            </div>

            <div
              className={`timeline__card ${
                activeIndex === index ? "active" : ""
              }`}
            >
              <h4>{item.date}</h4>
              <p>{item.title}</p>
              <p className="training__skills">
                <strong>Skills:</strong> {item.skills.join(", ")}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="cta__section">
        <h1 className="cta__heading">Ready, Set</h1>
        <p className="cta__text">
          Join forces with a skilled web developer and let’s create some web
          magic! Hit the button below to discuss your fantastic project ideas.
        </p>
        <Link to="/Contact">
          <button className="cta__button">Contact</button>
        </Link>
      </div>
    </div>
  );
}

export default Training;
